import { apiClient } from './client';
import type { ApiResponse, PagedResult } from '@/types/api.types';
import type {
  TransactionTypeDto,
  TransactionTypeListDto,
  TransactionTypeFilterDto,
  CreateTransactionTypeRequest,
  UpdateTransactionTypeRequest,
} from '@/types/transactionType.types';

export const transactionTypeApi = {
  /** GET /api/v1/transaction-types — paginated list with optional search/filter */
  getList: (filter?: TransactionTypeFilterDto) =>
    apiClient.get<ApiResponse<PagedResult<TransactionTypeListDto>>>('/transaction-types', {
      params: filter,
    }),

  /** GET /api/v1/transaction-types/{id} — full transaction type record */
  getById: (id: string) =>
    apiClient.get<ApiResponse<TransactionTypeDto>>(`/transaction-types/${id}`),

  /** GET /api/v1/transaction-types/by-code/{code} — returns 404 when not found */
  getByCode: (code: string) =>
    apiClient.get<ApiResponse<TransactionTypeDto>>(
      `/transaction-types/by-code/${encodeURIComponent(code)}`,
    ),

  /** POST /api/v1/transaction-types — create a new transaction type */
  create: (data: CreateTransactionTypeRequest) =>
    apiClient.post<ApiResponse<{ id: string }>>('/transaction-types', data),

  /** PUT /api/v1/transaction-types/{id} — update transaction type details */
  update: (id: string, data: UpdateTransactionTypeRequest) =>
    apiClient.put<ApiResponse<object>>(`/transaction-types/${id}`, data),

  /** DELETE /api/v1/transaction-types/{id} — soft-delete the transaction type */
  remove: (id: string) =>
    apiClient.delete<ApiResponse<object>>(`/transaction-types/${id}`),
};
